/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonGroupInfo,
    JsonGroupInfoFromJSON,
    JsonGroupInfoFromJSONTyped,
    JsonGroupInfoToJSON,
} from './JsonGroupInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonGroupInfo
 */
export interface ApiResultOfListOfJsonGroupInfo {
    /**
     * 
     * @type {Array<JsonGroupInfo>}
     * @memberof ApiResultOfListOfJsonGroupInfo
     */
    data?: Array<JsonGroupInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonGroupInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonGroupInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonGroupInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonGroupInfo
     */
    result?: ApiResultOfListOfJsonGroupInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonGroupInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonGroupInfoFromJSON(json: any): ApiResultOfListOfJsonGroupInfo {
    return ApiResultOfListOfJsonGroupInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonGroupInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonGroupInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonGroupInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonGroupInfoToJSON(value?: ApiResultOfListOfJsonGroupInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonGroupInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

